import { render, staticRenderFns } from "./StudiosListItem.vue?vue&type=template&id=139366ca&scoped=true&"
import script from "./StudiosListItem.vue?vue&type=script&lang=js&"
export * from "./StudiosListItem.vue?vue&type=script&lang=js&"
import style0 from "./StudiosListItem.vue?vue&type=style&index=0&id=139366ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139366ca",
  null
  
)

export default component.exports